// BOOSTRAP REQUIRED
import 'NodeModules/bootstrap/js/dist/util.js';
import 'NodeModules/bootstrap/js/dist/index.js';

// BOOTSTRAP UTILITIES
import 'NodeModules/bootstrap/js/dist/alert.js';
import 'NodeModules/bootstrap/js/dist/button.js';
import 'NodeModules/bootstrap/js/dist/carousel.js';
import 'NodeModules/bootstrap/js/dist/collapse.js';
import 'NodeModules/bootstrap/js/dist/dropdown.js';
import 'NodeModules/bootstrap/js/dist/modal.js';
import 'NodeModules/bootstrap/js/dist/popover.js';
import 'NodeModules/bootstrap/js/dist/tab.js';
import 'NodeModules/bootstrap/js/dist/tooltip.js';

// PLUGINS
import 'NodeModules/jquery.cookie/jquery.cookie.js';
import 'NodeModules/flickity/dist/flickity.pkgd.js';
import 'NodeModules/flickity-fade/flickity-fade.js';
import 'NodeModules/slick-carousel/slick/slick.min.js';
import 'nodelist-foreach-polyfill';

// COMMON

// COMMON
import 'OchsnerJS/common/_app.js';
import 'OchsnerJS/common/_captcha-validation.js';
import 'OchsnerJS/common/_flickity.js';
import 'OchsnerJS/common/_functions.js';
import 'OchsnerJS/common/_required.js';
import 'OchsnerJS/common/_button-stack.js';
import 'OchsnerJS/common/_button-toggle.js';
import 'OchsnerJS/common/_email-link-fix.js';
import 'OchsnerJS/common/_map-styling.js';
import 'OchsnerJS/common/_offcanvas.js';
import 'OchsnerJS/common/_persona.js';
import 'OchsnerJS/common/_sub-nav.js';

// CUSTOM
import 'OchsnerJS/promo/_sliders.js';
import 'OchsnerJS/www/_app.js';
import 'OchsnerJS/common/_load-global-search.js';
// import 'OchsnerJS/www/_location-search.js';
import 'OchsnerJS/www/_regional-landings.js';
import 'OchsnerJS/www/_regional-events.js';
import './scss/_app.promo.scss';
import 'OchsnerJS/common/_ems-banner.js';
